import React from 'react';
import UnknownThumbHtmlView from './UnknownHtml';
import UnknownThumbReactView from './Unknown';
const UnknownThumbView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(UnknownThumbHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(UnknownThumbReactView, props);
};
UnknownThumbView.displayName = 'UnknownThumbView';
export default UnknownThumbView;
